$(document).on('click', '.collapsible-panel .collapsible-panel-title', function () {
    const title = $(this);
    const collapsiblePanel = title.closest('.collapsible-panel');
    if (collapsiblePanel.hasClass('opened')) {
        collapsiblePanel.removeClass('opened');
    } else {
        collapsiblePanel.addClass('opened');
    }
});
